import { CanActivateFn, Router } from '@angular/router';
import { TokenStorageService } from '../services/token-storage.service';
import { inject } from '@angular/core';
import { MenuItem } from '../models/menu-item.model';
function checkModuleExists(modules: MenuItem[], linkName: string): boolean {
  if (!modules || modules.length === 0) return false;
  return modules.some(
    (m) =>
      m.linkName === linkName ||
      (!!m.subModules?.length && checkModuleExists(m.subModules, linkName)),
  );
}
export const privilegeGuard: CanActivateFn = (route) => {
  const auth = inject(TokenStorageService);
  const router = inject(Router);
  const requiredPrivileges: string[] | undefined = route.data?.['privileges'];
  const requiredModule: string | undefined = route.data?.['moduleName'];
  if (requiredModule) {
    const allModules = auth.allModulesWithBlocked();
    if (!checkModuleExists(allModules, requiredModule)) {
      return router.createUrlTree(['user-main/401']);
    }
  }
  if (!requiredPrivileges?.length) {
    return true;
  }
  const roles: string[] = auth.currentUser$()?.roles || [];
  if (roles.includes('ROLE_USER')) {
    return true;
  }
  const hasAnyPrivilege = requiredPrivileges.some((p) =>
    auth.hasOnePrivilege(p),
  );
  if (hasAnyPrivilege) {
    return true;
  }
  return router.createUrlTree(['user-main/401']);
};
